import React, { useEffect, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import { getConfig } from "../config";
import GuestStatusCard from "../components/GuestStatusCard";

const RECOVERY_MESSAGES = {
  // Backend redirect errors (via ?error=...)
  not_found: {
    title: "Geçersiz QR Kod",
    message: "Bu QR kod geçerli değil.",
  },
  disabled: {
    title: "QR Sipariş Devre Dışı",
    message: "Bu masa için QR sipariş devre dışı.",
  },
  server_error: {
    title: "Bir Hata Oluştu",
    message: "Sistem geçici olarak kullanılamıyor.",
  },
};

const REASON_MESSAGES = {
  // Frontend navigation reasons (via ?reason=...)
  expired: {
    title: "Oturum Süresi Doldu",
    message: "QR oturumunuzun süresi doldu.",
  },
  missing: {
    title: "Oturum Bulunamadı",
    message: "QR oturumu bulunamadı.",
  },
  invalid: {
    title: "Geçersiz Oturum",
    message: "QR oturumu geçersiz.",
  },
  session_error: {
    title: "Oturum Hatası",
    message: "QR oturumu doğrulanamadı.",
  },
};

const DEFAULT_RECOVERY = {
  title: "QR Kod Gerekli",
  message: "Sipariş vermek için QR kod taramanız gerekiyor.",
};

const QRScanPage = () => {
  const [loading, setLoading] = useState(false);
  const params = useParams();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const urlSlug = params.slug;

    if (urlSlug) {
      // Slug-based flow: redirect to backend endpoint
      // Backend will validate slug, set HttpOnly cookie, and redirect back to SPA
      // /q/:slug is registered at server root, not under /api/v1
      setLoading(true);
      const backendOrigin = getConfig().apiUrl.replace(/\/api\/v1\/?$/, "");
      window.location.href = `${backendOrigin}/q/${encodeURIComponent(urlSlug)}`;
    }
  }, [params.slug]);

  if (loading) {
    return (
      <div className="guest-qr-page">
        <GuestStatusCard
          variant="info"
          title="Yönlendiriliyorsunuz"
          message="Masa bilgileriniz ayarlanıyor. Lütfen bekleyin."
          busy
        />
      </div>
    );
  }

  // Recovery mode: determine context from query params
  const error = searchParams.get("error");
  const reason = searchParams.get("reason");

  let recovery;
  if (error && RECOVERY_MESSAGES[error]) {
    recovery = RECOVERY_MESSAGES[error];
  } else if (reason && REASON_MESSAGES[reason]) {
    recovery = REASON_MESSAGES[reason];
  } else {
    recovery = DEFAULT_RECOVERY;
  }

  return (
    <div className="guest-qr-page">
      <GuestStatusCard variant="warning" title={recovery.title} message={recovery.message}>
        <div className="guest-help-text">
          Lütfen masanızdaki QR kodu telefonunuzun kamerasıyla tarayarak yeniden giriş yapın.
        </div>
        <p className="guest-recovery-note mb-0">
          Yardıma ihtiyacınız olursa lütfen garsonumuzdan destek isteyin.
        </p>
      </GuestStatusCard>
    </div>
  );
};

export default QRScanPage;
